/** Merge tags for QMS vault workflow emails (send for review / send for approval). */

export const QMS_VAULT_REVIEW_EMAIL_MERGE_TAGS = [
  { tag: "{{StaffName}}", entityName: "StaffName", description: "Reviewer display name" },
  { tag: "{{SentByName}}", entityName: "SentByName", description: "Document owner who sent for review" },
  { tag: "{{DocumentTitle}}", entityName: "DocumentTitle", description: "Document title" },
  { tag: "{{DocumentCode}}", entityName: "DocumentCode", description: "Document category number + version" },
  {
    tag: "{{DocumentOpenLink}}",
    entityName: "DocumentOpenLink",
    description: "Open document button — use this only (do not build your own link)",
  },
  { tag: "{{DocumentId}}", entityName: "DocumentId", description: "Document unique id" },
  { tag: "{{VersionNumber}}", entityName: "VersionNumber", description: "Document version number" },
  {
    tag: "{{OrganizationName}}",
    entityName: "OrganizationName",
    description: "Organisation display name",
  },
];

export const QMS_VAULT_APPROVE_EMAIL_MERGE_TAGS = [
  { tag: "{{StaffName}}", entityName: "StaffName", description: "Approver display name" },
  { tag: "{{SentByName}}", entityName: "SentByName", description: "Document owner who sent for approval" },
  { tag: "{{DocumentTitle}}", entityName: "DocumentTitle", description: "Document title" },
  { tag: "{{DocumentCode}}", entityName: "DocumentCode", description: "Document category number + version" },
  {
    tag: "{{DocumentOpenLink}}",
    entityName: "DocumentOpenLink",
    description: "Open document button — use this only (do not build your own link)",
  },
  { tag: "{{DocumentId}}", entityName: "DocumentId", description: "Document unique id" },
  { tag: "{{VersionNumber}}", entityName: "VersionNumber", description: "Document version number" },
  {
    tag: "{{OrganizationName}}",
    entityName: "OrganizationName",
    description: "Organisation display name",
  },
];
